import { useRef } from 'react'
import { Flex, TextInput, UnstyledButton } from '@mantine/core'

import type { ChatMessageInputProps } from '@/components/@Shared/Chat/partials/ChatMessageInput/ChatMessageInput.types'

import PlaneIcon from '@/assets/icons/plane.svg?react'

import classes from './ChatMessageInput.module.css'

const DEFAULT_PLACEHOLDER = 'Write a message...'

export function ChatMessageInput({
  disabled,
  onMessageSend,
  placeholder = DEFAULT_PLACEHOLDER,
}: ChatMessageInputProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleSendMessage = () => {
    if (disabled) return

    const message = inputRef.current?.value

    if (!message) {
      return
    }

    onMessageSend(message)
    inputRef.current!.value = ''
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSendMessage()
    }
  }

  return (
    <Flex className={classes.container}>
      <TextInput
        ref={inputRef}
        className={classes.input}
        disabled={disabled}
        onKeyDownCapture={handleKeyDown}
        placeholder={placeholder}
        variant="unstyled"
      />

      <UnstyledButton
        className={classes.sendButton}
        disabled={disabled}
        onClick={handleSendMessage}
      >
        <PlaneIcon />
      </UnstyledButton>
    </Flex>
  )
}
